import React from 'react'
import { createRoot } from 'react-dom/client'
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux'
import store, { history } from './store'
import { StyledEngineProvider } from '@mui/material/styles';
import { ParallaxProvider } from 'react-scroll-parallax';
import { SnackbarProvider } from 'notistack';
import ColorModeProvider from './theme/ColorModeProvider';
import * as Sentry from '@sentry/react';
import App from './containers/app'
import AppLoadError from './components/AppLoadError'
import PageViewTracker from './components/PageViewTracker'

import 'flag-icon-css/css/flag-icon.min.css';
import 'sanitize.css/sanitize.css';
import './index.css';

const target = document.querySelector('#root')

const root = createRoot(target)
root.render(
  <Router history={history}>
    <PageViewTracker />
    <StyledEngineProvider injectFirst>
      <ColorModeProvider>
        <Provider store={store}>
          <SnackbarProvider
            maxSnack={5}
            dense={true}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            classes={{ containerRoot: 'ly-snackbar-container', containerAnchorOriginBottomLeft: 'bulk-snackbar-container' }}
          >
            <ParallaxProvider>
              {/* a render error anywhere left a white page; Sentry's boundary still reports it */}
              <Sentry.ErrorBoundary fallback={({ error }) => <AppLoadError message={error?.message} />}>
                <App />
              </Sentry.ErrorBoundary>
            </ParallaxProvider>
          </SnackbarProvider>
        </Provider>
      </ColorModeProvider>
    </StyledEngineProvider>
  </Router>
)
